export const warnings = (state={}, action) => {
  return state;
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/reducers/warnings.js